export const NIL_FILTER_VALUE = 'DATA_EXPLORATION_NO_VALUE_PLACEHOLDER';
export const NIL_FILTER_LABEL = 'N/A';
export const EMPTY_LABEL = 'Empty';
export const NOT_SET = 'Not set';

export const METADATA_ALL_VALUE = 'DATA_EXPLORATION_ALL_METADATA_VALUES';

export const COMMON_INFO_CONTENT =
  'The filters in this section are applied across all of the resource types';

export const SPECIFIC_INFO_CONTENT =
  'The filters in this section are only applicable for the currently selected resource type';
